namespace GeniuzPOS.AdvPromo {
@Serenity.Decorators.registerClass()
export class Adv05ItemDtEditor extends Serenity.Extensions.GridEditorBase<Adv05ItemDtRow> {
    protected getColumnsKey() { return Adv05ItemDt2Columns.columnsKey; }
    protected getDialogType() { return Adv05ItemDtDialog; }
    protected getLocalTextPrefix() { return Adv05ItemDtRow.localTextPrefix; }
    protected getService() { return Adv05ItemDtService.baseUrl; }


    constructor(container: JQuery) {
        super(container);
    }
    protected getButtons() {
        var buttons = super.getButtons();

        // remove first button (Add button)
        buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
        buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

        // Add buttons import excel, pdf      
        // buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
        //     grid: this,
        //     service: Adv05ItemDtService.baseUrl + '/ListExcel',
        //     onViewSubmit: () => true,
            
        //     separator: true
        // }));

        // buttons.push(
        //     {
        //         title: 'Export',
        //             cssClass: 'button-export',
        //             icon: 'fa-cloud-download',
        //             onClick: () => {
        //                 let _orderDetailsRows: Adv05ItemDtRow[] = [];
        //                 this.view.getItems().forEach((v, i) => {
        //                     _orderDetailsRows.push();
        //                 });;
        //                 Q.postToService({
        //                     service: Adv05ItemDtService.baseUrl + '/ListExcel',
        //                     request: {
        //                         Adv05ItemDtRow: _orderDetailsRows,
        //                     },
        //                     target: '_blank'
        //                 });
        //             }
        //     }
        // );
       
        return buttons;
    }



    protected getSlickOptions() {
        var opt = super.getSlickOptions();
        opt.showFooterRow = true;
        // opt.frozenColumn = 1;
        return opt;
    }

    protected getViewOptions() {
        var opt = super.getViewOptions();
        opt.localSort = true;
        return opt;
    }

    

    
}}